/** Planting items that are not seeds (pure, DOM-free). */
import { AIR, CAVE_VINES_ID, IS_SOLID } from '../../blocks';
import { I } from '../itemIds';

export interface PlantWorld { getBlock(x: number, y: number, z: number): number }

/**
 * Glow berries used on the underside of a block (face normal pointing down) plant cave vines in the air cell
 * below it (vanilla: the item is a BlockItem for `cave_vines`, which hangs from the block above). Returns
 * the cell to fill, or null when the click is not a valid plant spot. Clicking the side or top eats the berries instead.
 */
export function glowBerryPlantCell(w: PlantWorld, itemId: number, x: number, y: number, z: number, ny: number): [number, number, number] | null {
  if (itemId !== I.GLOW_BERRIES || ny !== -1) return null;
  if (IS_SOLID[w.getBlock(x, y, z)] !== 1) return null;
  if (w.getBlock(x, y - 1, z) !== AIR) return null;
  return [x, y - 1, z];
}

export const GLOW_BERRY_PLANT = CAVE_VINES_ID;
